/**This file contains the hard-coded definition of gliding frameworks
 * configured on AdvisorArch. This is a short-term solution, and should be
 * replaced later. The purpose is to provide a basis for the app to render the
 * the pie charts.
 */

import { AllocationType, GlidingStoppingPoint } from "@/util/planning-util";

export type GlidingFramework = {
  timeLimit: number;
  startingAllocation: Partial<Record<AllocationType, number>>;
  stoppingPoints?: GlidingStoppingPoint[];
};

export function getMajorPurchaseGlidingFrameworks(
  timeHorizonYears: number,
): GlidingFramework {
  if (timeHorizonYears <= 2) {
    return {
      timeLimit: 2,
      startingAllocation: {
        "Money Market": 100,
      },
    };
  } else if (timeHorizonYears <= 5) {
    return {
      timeLimit: 5,
      startingAllocation: {
        Growth: 100,
        "Capital Preservation": 0,
        "Money Market": 0,
      },
      stoppingPoints: [
        {
          timeUnit: "MONTH",
          timeValue: 24,
          allocations: {
            Growth: 0,
            "Capital Preservation": 100,
            "Money Market": 0,
          },
        },
        {
          timeUnit: "MONTH",
          timeValue: 60,
          allocations: {
            Growth: 0,
            "Capital Preservation": 0,
            "Money Market": 100,
          },
        },
      ],
    };
  } else if (timeHorizonYears <= 10) {
    return {
      timeLimit: 10,
      startingAllocation: {
        Growth: 100,
        "Capital Preservation": 0,
        "Money Market": 0,
      },
      stoppingPoints: [
        {
          timeUnit: "MONTH",
          timeValue: 84,
          allocations: {
            Growth: 0,
            "Capital Preservation": 100,
            "Money Market": 0,
          },
        },
        {
          timeUnit: "MONTH",
          timeValue: 120, // 10 years
          allocations: {
            Growth: 0,
            "Capital Preservation": 0,
            "Money Market": 100,
          },
        },
      ],
    };
  } else if (timeHorizonYears <= 15) {
    return {
      timeLimit: 15,
      startingAllocation: {
        Growth: 100,
        "Capital Preservation": 0,
        "Money Market": 0,
      },
      stoppingPoints: [
        {
          timeUnit: "MONTH",
          timeValue: 144,
          allocations: {
            Growth: 0,
            "Capital Preservation": 100,
            "Money Market": 0,
          },
        },
        {
          timeUnit: "MONTH",
          timeValue: 180, // 15 years
          allocations: {
            Growth: 0,
            "Capital Preservation": 0,
            "Money Market": 100,
          },
        },
      ],
    };
  } else if (timeHorizonYears <= 20) {
    return {
      timeLimit: 20,
      startingAllocation: {
        Growth: 100,
        "Capital Preservation": 0,
        "Money Market": 0,
      },
      stoppingPoints: [
        {
          timeUnit: "MONTH",
          timeValue: 204, // 2 years
          allocations: {
            Growth: 0,
            "Capital Preservation": 100,
            "Money Market": 0,
          },
        },
        {
          timeUnit: "MONTH",
          timeValue: 240, // 20 years
          allocations: {
            Growth: 0,
            "Capital Preservation": 0,
            "Money Market": 100,
          },
        },
      ],
    };
  } else if (timeHorizonYears <= 25) {
    return {
      timeLimit: 25,
      startingAllocation: {
        Growth: 100,
        "Capital Preservation": 0,
        "Money Market": 0,
      },
      stoppingPoints: [
        {
          timeUnit: "MONTH",
          timeValue: 264, // 2 years
          allocations: {
            Growth: 0,
            "Capital Preservation": 100,
            "Money Market": 0,
          },
        },
        {
          timeUnit: "MONTH",
          timeValue: 300, // 25 years
          allocations: {
            Growth: 0,
            "Capital Preservation": 0,
            "Money Market": 100,
          },
        },
      ],
    };
  } else {
    return {
      timeLimit: 30,
      startingAllocation: {
        Growth: 100,
        "Capital Preservation": 0,
        "Money Market": 0,
      },
      stoppingPoints: [
        {
          timeUnit: "MONTH",
          timeValue: 324,
          allocations: {
            Growth: 0,
            "Capital Preservation": 100,
            "Money Market": 0,
          },
        },
        {
          timeUnit: "MONTH",
          timeValue: 360, // 30 years
          allocations: {
            Growth: 0,
            "Capital Preservation": 0,
            "Money Market": 100,
          },
        },
      ],
    };
  }
}
